if($('#mayo-search').length) {

    let searchContainer = $('#mayo-search'),
        searchForm = $('#mayo-search-form'),
        searchInput = $('#mayo-search-input'),
        resultsContainer = $('#mayo-search-results'),
        paginationContainer = $('#mayo-pagination-container'),
        paginationDisplay = $('.mayo-pagination-display'),
        previousSearch = '',
        initialSearchComplete = false,
        // letterFilter = '',
        // letterClearButton = $('.mayo-clear-letter'),
        // letterFilterButtons = $('.mayo-filter-letter button'),
        topicFilterItems = $('.mayo-filter-topic'),
        currentFilterTags = $('.mayo-current-filter-tags'),
        clearFilterButton = $('.tags-filter-reset .clear'),
        page = 1;

    searchInput.on('keyup update', function() {
        if(previousSearch.length > 0 && searchInput.val().length === 0) {
            mayoSearch();
        }

        previousSearch = searchInput.val();
    });

    searchInput.on('keyup update', debounce(function () {

        if(searchInput.val().length > 2) {
            mayoSearch();
        }

    }, 500));

    function debounce (fn, delay) {
        var timeoutID = null
        return function () {
            clearTimeout(timeoutID)
            var args = arguments
            var that = this
            timeoutID = setTimeout(function () {
                fn.apply(that, args)
            }, delay)
        }
    }

    searchForm.on('submit', function(e) {
        e.preventDefault();

        mayoSearch();
    });

    $(document).on('click', '.mayo-page-link', function (e) {
        e.preventDefault();
        page = $(this).data('page');
        mayoSearch();
    });

    $(document).on('click', '.mayo-page-prev', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page--;
        mayoSearch();
    });

    $(document).on('click', '.mayo-page-next', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page++;
        mayoSearch();
    });

    // letterFilterButtons.on('click', function() {
    //     if($(this).hasClass('service-clear-letter')) return;
    //
    //     if($(this).hasClass('is-checked')) {
    //         $(this).removeClass('is-checked');
    //         letterFilter = '';
    //         mayoSearch();
    //         return;
    //     }
    //
    //     letterFilterButtons.removeClass('is-checked');
    //     $(this).addClass('is-checked');
    //     letterClearButton.addClass('active');
    //     letterFilter = $(this).data('letter');
    //     mayoSearch();
    // });
    //
    // letterClearButton.on('click', function() {
    //     letterFilterButtons.removeClass('is-checked');
    //     $(this).removeClass('active');
    //     letterFilter = '';
    //     mayoSearch();
    // });

    topicFilterItems.on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-checked');
        mayoSearch();
    });

    $(document).on('click', '.mayo-current-filter-tags button', function () {
        $('.mayo-filter-topic-' + $(this).data('topic')).parent().removeClass('is-checked');
        mayoSearch();
    });

    clearFilterButton.on('click', function() {
        topicFilterItems.parent().removeClass('is-checked');
        mayoSearch();
    });

    function showHideClearButton() {

        if(topicFilterItems.parent().hasClass('is-checked')) {
            clearFilterButton.removeClass('hiding');
        } else {
            clearFilterButton.addClass('hiding');
        }

    }


    function mayoSearch() {

        $('#mayo-search-container').addClass('loading');

        let topicFilters = [];

        topicFilterItems.each(function() {
            if($(this).parent().hasClass('is-checked')) {
                topicFilters.push($(this).data('topic'));
            }
        });

        showHideClearButton();

        $.post("/wp-admin/admin-ajax.php", {
            'action': 'mayo_search',
            'query': searchInput.val(),
            // 'letter': letterFilter,
            'topics': topicFilters,
            'page': page,
        }, function (response) {

            resultsContainer.html(response.data.results);
            paginationContainer.html(response.data.pagination);
            paginationDisplay.html(response.data.pagination_display);
            currentFilterTags.html(response.data.current_filter_tags);

            $('html, body').animate({
                scrollTop: $('#mayo-search-container').offset().top
            }, 500);

            $('#mayo-search-container').removeClass('loading');

        });

    }

}

if($('#mayo-search-landing').length) {

    let ailments = window.ailments,
        ailmentLabels = $('.ailment-label');

    cycleWords();

    setInterval(function() {
        cycleWords();
    }, 5000);

    function cycleWords() {
        ailmentLabels.each(function() {
            let delay = Math.floor(Math.random() * 2000);

            console.log(delay);


            setTimeout(() => {
                $(this).addClass('hiding');
                setTimeout(() => {
                    $(this).text(ailments[Math.floor(Math.random() * ailments.length)]);
                }, 301);
                setTimeout(() => {
                    $(this).removeClass('hiding');
                }, 302);
            }, delay);

        });
    }

}
